import { Images } from '@interfaces/api/image'
import { axiosPostFilesData } from '@services/api/axios'

export const apiImageUpload = async (data: FormData) =>
  await axiosPostFilesData<Images>('/upload', data)
